import { InstanceFactory, PageFactory } from "@amzn/ask-legal-domain";
import { BreadcrumbGroup } from "@amzn/awsui-components-react";
import * as React from "react";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { DecisionTreeEdit } from "../../components/decision-tree-container/DecisionTreeEdit";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";

export const decisionTreeRoutes = [{
    path: "/decision-tree/:containerId/edit/",
    content: <DecisionTreeEdit.Comp />,
    breadcrumbs: () => <BreadcrumbGroup items={[]} />,
    header: () => {
        const { containerId } = useRoutedParamsWithContext();
        const instanceId = InstanceFactory.fromEntityId(containerId!);
        return <SherpaHeader headerType="Other" instanceId={instanceId} />;
    },
    footer: () => {
        const { containerId } = useRoutedParamsWithContext();
        return <SherpaFooter
            variant="AdminPortal"
            entityId={PageFactory.fromEntityId(containerId!)}
        />;
    }
}];
